import bridge from './vue-constructor-bridge';
import NewRelicMonitoringService from './services/new-relic-plugin-service';
import DataDogMonitoringService from './services/datadog-plugin-service';

// Fans a single monitoring event out to every provider we currently report to.
// New Relic and Datadog run side by side; when New Relic is retired, drop its
// service from this fan-out and the 130+ call sites stay untouched.
const MonitoringEventTrackingPlugin = {
  install(app, { store }) {
    const newRelicService = NewRelicMonitoringService(store);
    const dataDogService = DataDogMonitoringService(store);

    dataDogService.init();

    const triggerMonitoringEvent = (...args) => Promise.allSettled([
      newRelicService.triggerNewRelicEvent(...args),
      dataDogService.triggerDataDogEvent(...args)
    ]);

    // Set on the bridge so store/service files that do
    // `import bridge from '@/plugins/vue-constructor-bridge'; bridge.triggerNewRelicEvent(...)` can find it.
    // triggerNewRelicEvent is kept as a legacy alias so existing call sites fan out
    // to both providers without changes.
    bridge.triggerNewRelicEvent = triggerMonitoringEvent;
    bridge.triggerDataDogEvent = dataDogService.triggerDataDogEvent;
    bridge.triggerMonitoringEvent = triggerMonitoringEvent;

    app.config.globalProperties.$triggerNewRelicEvent = triggerMonitoringEvent;
    app.config.globalProperties.$triggerDataDogEvent = dataDogService.triggerDataDogEvent;
    app.config.globalProperties.$triggerMonitoringEvent = triggerMonitoringEvent;
  }
};

export default MonitoringEventTrackingPlugin;
